import React, { useEffect } from 'react';
import EntryFormHeader from '../../components/header/EntryFormHeader';

interface PersonalEntryFormReturnToOriginalTabType {
}

const PersonalEntryFormReturnToOriginalTab: React.FC<PersonalEntryFormReturnToOriginalTabType> = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="bg-gray-50">
        <EntryFormHeader currentStep={4} />
        <div className="complete-card w-[95%] sm:w-[90%] max-w-[800px] mx-auto p-8 my-8">
          <svg className="w-16 h-16 mx-auto mb-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>

          <h1 className="text-2xl font-bold mb-4">元の画面に戻ってご確認ください</h1>

          <p className="text-gray-600 mb-6 leading-relaxed">
            本人確認アプリでの操作は完了しました。<br />
            iPhoneでChromeなどをご利用の場合、このように<span className="font-semibold">新しいタブや別のブラウザ</span>が開くことがあります。
          </p>

          <div className="info-box text-left">
            <p className="font-semibold mb-1">この画面での操作は必要ありません。</p>
            <p>
              お手続きの状況は、最初に本人確認を開始した<span className="font-semibold">元の画面（タブ）</span>に表示されています。お手数ですが、元の画面に戻って結果をご確認ください。この画面は閉じていただいて問題ありません。
            </p>
          </div>

          <div className="mt-6 text-left max-w-md mx-auto">
            <h2 className="font-semibold mb-2 text-gray-700">元の画面に戻る方法</h2>
            <ol className="text-sm space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="mr-2">1.</span>
                <span>ブラウザのタブ一覧を開きます。</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">2.</span>
                <span>本人確認を開始した元のタブ（申請フォームの画面）を選びます。</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">3.</span>
                <span>元の画面に表示された案内に従って、お手続きを完了してください。</span>
              </li>
            </ol>
          </div>

          <div className="notice-box text-left mt-6">
            <p className="text-sm">
              ※ これはiPhoneとブラウザ（iOS）の仕様によるもので、不具合ではありません。元の画面が見つからない場合は、お手数ですが最初から申請をやり直してください。
            </p>
          </div>

          <p className="mt-8 text-gray-700 font-bold">
            元の画面に戻って、お手続きの結果をご確認ください。
          </p>
        </div>
      </div>
    </>
  );
};

export default PersonalEntryFormReturnToOriginalTab;
